import type { HelpIllustration as HelpIllustrationDefinition } from '../diagnosis/types';

interface HelpIllustrationProps {
  illustration: HelpIllustrationDefinition;
}

export function HelpIllustration({ illustration }: HelpIllustrationProps) {
  return (
    <figure className="help-illustration">
      <img src={illustration.src} alt={illustration.alt} loading="lazy" />
      <figcaption>{illustration.caption}</figcaption>
    </figure>
  );
}
